import { S3StorageSVG } from '@sbercloud/uikit-product-icons';

export { S3StorageSVG as S3Compatible, S3StorageSVG as S3CompatibleSVG };
